import z from "zod";

export const ThemeSchema = z.object({
  preset: z.union([z.literal("light"), z.literal("dark")]).optional(),
  borderRadius: z
    .object({
      extraSmall: z.string().optional(),
      small: z.string().optional(),
      large: z.string().optional(),
      extraLarge: z.string().optional(),
    })
    .optional(),
  canvasColor: z.string().optional(),
  font: z
    .object({
      family: z.string().optional(),
      url: z.string().optional(),
    })
    .optional(),
  colors: z
    .object({
      "900": z.string().optional(),
      "800": z.string().optional(),
      "700": z.string().optional(),
      "600": z.string().optional(),
      "500": z.string().optional(),
      "400": z.string().optional(),
      "300": z.string().optional(),
      "200": z.string().optional(),
      "100": z.string().optional(),
      "50": z.string().optional(),
      "10": z.string().optional(),
      white: z.string().optional(),
      primary: z.string().optional(),
      "primary-light": z.string().optional(),
      "primary-light-2": z.string().optional(),
      "primary-dark": z.string().optional(),
      secondary: z.string().optional(),
      "secondary-light": z.string().optional(),
      "secondary-light-2": z.string().optional(),
      error: z.string().optional(),
      "error-light": z.string().optional(),
      success: z.string().optional(),
      "success-light": z.string().optional(),
      active: z.string().optional(),
      "active-2": z.string().optional(),
      "active-3": z.string().optional(),
      "locked-structure": z.string().optional(),
      "locked-content": z.string().optional(),
    })
    .optional(),
});

export type ITheme = z.infer<typeof ThemeSchema>;
